import React from 'react';

const ReactNativeDeveloper = () => {
  const styles = {
    badgeRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10,
      alignItems: 'center',
      marginTop: 6,
      marginBottom: 16,
      padding: '10px 12px',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      fontSize: 13.5,
      color: '#111827',
      lineHeight: 1.4,
    },
    badgeDot: { color: '#9ca3af' },

    p: {
      fontSize: 14.5,
      lineHeight: 1.75,
      margin: '10px 0',
      color: '#111827',
    },

    h2: {
      fontSize: 18,
      margin: '26px 0 10px',
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    h3: {
      margin: '18px 0 8px',
      fontSize: 15,
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    ul: {
      margin: '10px 0 10px 22px',
      fontSize: 14.5,
      lineHeight: 1.75,
      color: '#111827',
    },

    callout: {
      marginTop: 14,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #fde68a',
      background: '#fffbeb',
      lineHeight: 1.6,
    },
    calloutTitle: {
      margin: 0,
      fontSize: 14,
      fontWeight: 900,
      color: '#111827',
      letterSpacing: '-0.01em',
    },
    calloutText: {
      margin: '6px 0 0',
      fontSize: 14.5,
      color: '#111827',
    },

    highlightBox: {
      marginTop: 18,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #dbeafe',
      background: '#eff6ff',
      lineHeight: 1.6,
    },
    highlightText: {
      margin: 0,
      fontSize: 14.5,
      color: '#111827',
    },
  };

  return (
    <div>
      <h2 style={styles.h2}>Senior React Native &amp; React Developer</h2>
      <div style={styles.badgeRow}>
        <span>
          📍 <strong>India · Hyderabad</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🌍 <strong>Remote</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          📱 <strong>Expo / Expo Go</strong>
        </span>
      </div>
      <p style={styles.p}>
        We’re looking for a skilled React Native + React Developer who enjoys moving fast, taking
        ownership, and working closely with the founding team. You’ll help build and ship production
        features across mobile and web, and support releases to the App Store and Play Store.
      </p>
      <h3 style={styles.h3}>Experience</h3>
      <ul style={styles.ul}>
        <li>4–6 years of hands-on experience in React and React Native</li>
        <li>Strong experience with Expo / Expo Go</li>
        <li>
          Proven experience with App Store &amp; Play Store publishing (builds, certificates,
          provisioning, review process, release timelines)
        </li>
      </ul>
      <h3 style={styles.h3}>Technical Skills</h3>
      <ul style={styles.ul}>
        <li>
          React Native with <strong>Expo / Expo Go</strong> for production-ready mobile apps
        </li>
        <li>React.js (18+) with modern hooks and component patterns</li>
        <li>Context API and modern state management patterns</li>
        <li>REST API integration and robust async data handling</li>
        <li>Socket.IO and real-time communication features</li>
        <li>
          App Store &amp; Play Store deployments — builds, certificates, provisioning profiles,
          review process, and production releases
        </li>
        <li>Debugging, performance optimization, and production readiness</li>
        <li>Ensuring smooth app deployments, monitoring, and post-release stability</li>
        <li>Performance profiling, debugging, and production hardening</li>
        <li>Ownership of release quality, post-launch monitoring, and stability improvements</li>
      </ul>
      <h3 style={styles.h3}>Work Environment</h3>
      <ul style={styles.ul}>
        <li>Comfortable working in a small startup team</li>
        <li>Willing to support and collaborate with other developers</li>
        <li>Takes ownership and can work independently</li>
      </ul>
      <div style={styles.callout}>
        <p style={styles.calloutTitle}>Working Hours (Mandatory)</p>
        <p style={styles.calloutText}>
          India Time: <strong>7:00 PM – 1:00 AM</strong> (Aligned with <strong>USA CST</strong>)
        </p>
      </div>
      {/* <h3 style={styles.h3}>Compensation</h3> */}
      {/* <ul style={styles.ul}>
        <li>
          <strong>₹10,00,000 per annum</strong> (₹10 LPA)
        </li>
      </ul> */}
      <h3 style={styles.h3}>What We’re Looking For</h3>
      <ul style={styles.ul}>
        <li>Startup mindset and strong problem-solving skills</li>
        <li>Clear communication and collaboration</li>
        <li>Flexible, growth-oriented attitude</li>
      </ul>
      <h3 style={styles.h3}>Why Join Us?</h3>
      <ul style={styles.ul}>
        <li>Direct work with founders</li>
        <li>High ownership and high impact</li>
        <li>Opportunity to grow with the company as we scale</li>
      </ul>
      <div style={styles.highlightBox}>
        <p style={styles.highlightText}>
          If you’ve shipped production apps and love building fast in a startup environment,&nbsp;
          <strong>we’d love to talk.</strong>
        </p>
      </div>

      <div
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 14,
          border: '2px solid #FF6138',
          background: '#fff2ecff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: '#111827',
                letterSpacing: '-0.01em',
              }}
            >
              Apply by Email
            </div>
            <div style={{ marginTop: 6, fontSize: 13.5, color: '#374151', lineHeight: 1.6 }}>
              Email your <strong>CV/Resume</strong> and mention the <strong>Job Title</strong> in
              the subject line.
            </div>
          </div>

          <a
            href='mailto:jobs@singlecombo.com?subject=Application%20-%20Senior%20React%20Native%20%26%20React%20Developer%20(Expo)'
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 12px',
              borderRadius: 12,
              border: '1px solid #dbeafe',
              background: '#eff6ff',
              color: '#111827',
              textDecoration: 'none',
              fontSize: 13.5,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
            aria-label='Email jobs@singlecombo.com'
          >
            ✉️ jobs@singlecombo.com
          </a>
        </div>

        <div
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gap: 8,
          }}
        >
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            <strong style={{ color: '#111827' }}>Subject:</strong> Application - Senior React Native
            & React Developer (Expo)
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
            <strong style={{ color: '#111827' }}>Include:</strong> Name • Phone • Location
            (India/Hyderabad) • Portfolio/GitHub • Apps published (links) • Availability (7pm–1am
            IST)
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactNativeDeveloper;
